import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
//UI
import HomeLayout from '../../../layouts/HomeLayout';
import BtnTable from '../../../components/buttons/BtnTable';
import HeaderSimple from '../../../components/headers/catalogs/HeaderSimple';
import MainLoader from '../../../components/Loaders/MainLoader';
import IconStatus from '../../../components/icons/IconStatus';
import Error from '../../../components/errors/Error';
//SLICE
import { deleteEventThunk, getEventsThunk } from '../../../store/slices/catalogs/events.slice';
import { FaCalendar, FaTimesCircle } from 'react-icons/fa';
import { FaMapLocation, FaTimeline } from 'react-icons/fa6';
import BtnAdd from '../../../components/buttons/BtnAdd';


const EventsList = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { events, message, error } = useSelector(state => state.events);
    const isLoading = useSelector(state => state.isLoadingSlice);

    useEffect(() => {
        dispatch(getEventsThunk());
    }, []);

    if (message === "Registro eliminado correctamente") {
        dispatch(getEventsThunk());
    }

    const handleDelete = (event_id) => {
        dispatch(deleteEventThunk(event_id));
    };

    return (
        <HomeLayout>
            {isLoading ? (
                <MainLoader />
            ) : (
                <div className='mx-5 my-5 w-full'>
                    {error ? <Error state={error} /> : " "}
                    <div className='flex w-full items-center justify-between p-2 border mb-2 shadow-sm'>
                        <HeaderSimple title={t("Eventos")} />
                        <div className='flex gap-2 items-center'>
                            <BtnAdd to={`/panel/events/event_new`} />
                        </div>
                    </div>
                    <div className="h-[90%] flex flex-col  rounded overflow-hidden">
                        <div className="overflow-y-auto flex-1 contenedor">
                            <table className="min-w-full table-zebra table-fixed border-collapse text-[13px] text-left">
                                <thead className="sticky top-0 bg-white">
                                    <tr className='text-left h-[50px] bg-p-orange/80 text-white'>
                                        <th className='w-[25px]'></th>
                                        <th>{t("Evento")}</th>
                                        <th>{t("Datos del evento")}</th>
                                        <th>{t("Descripcion")}</th>
                                        <th>{t("Imágen")}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {events?.map((event) => (
                                        <tr className='h-[50px]' key={event.id}>
                                            <td className='p-2'><IconStatus active={event.active} /></td>
                                            <td>{event.name}</td>
                                            <td>
                                                <div className='flex flex-col gap-1'>
                                                    <p className='flex gap-2 items-center'><FaCalendar />{event.fecha}</p>
                                                    <p className='flex gap-2 items-center'><FaTimesCircle />{event.hora}</p>
                                                    <p className='flex gap-2 items-center'><FaMapLocation />{event.locacion}</p>
                                                </div>
                                            </td>
                                            <td>{event.descripcion}</td>
                                            <td>{event.imagen}</td>
                                            <td>
                                                <div className='flex gap-1 justify-end items-center h-[50px] p-2'>
                                                    <BtnTable action="edit" to={`/panel/events/${event.id}`} />
                                                    <BtnTable title={t("event_delete")} action="delete" onclick={() => handleDelete(event.id)} />
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot className="sticky bottom-0 z-10 bg-gray-100 text-gray-700">
                                    <tr>
                                        <td colSpan={6} className="text-right p-2">
                                            Total de registros:{" "}
                                            <span className="text-p-sky text-[18px]">{events?.length ?? 0}</span>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>              
                </div>
            )}
        </HomeLayout>
    );
};

export default EventsList;